export const getFbcCookie = () => {
	const fbcCookie = document.cookie
		.split(";")
		.find((c) => c.trim().startsWith("_fbc="))

	const fbcCookieFallback = document.cookie
		.split(";")
		.find((c) => c.trim().startsWith("_fbc_fallback="))

	return fbcCookie
		? fbcCookie.split("=")?.[1] || null
		: fbcCookieFallback
			? fbcCookieFallback.split("=")?.[1] || null
			: null
}

export const getFbpCookie = () => {
	const fbpCookie = document.cookie
		.split(";")
		.find((c) => c.trim().startsWith("_fbp="))
	return fbpCookie ? fbpCookie.split("=")?.[1] || null : null
}
